
const typeEnumConst = {
	saleNum: 0,
	customerFlow: 1,
	turnoverRatio: 2,
	associatedPurchaseRate: 5,
};

export const message = {
	/**
	 * 常量
	 */
	'constant_yuan': '元',                          // 元
	'constant_wan': '万',                            // 常量万
	'constant_yi': '亿',                            // 常量亿
	'constant_day': '日',                            // 日
	'constant_week': '周',                            // 周
	'constant_month': '月',                          // 月
	'constant_month_short': '月',                          // 月
	'constant_year': '年',                           // 年
	'constant_quarter_short': '季',                 // 季
	'constant_xiaoshoue': '销售额',                // 销售额
	'constant_liandailv': '连带率',                // 连带率
	'constant_kedanjia': '客单价',                // 客单价
	'constant_dingdanshu': '订单数',                // 订单数
	'constant_renxiao': '人效',                // 人效
	'constant_pingxiao': '坪效',                // 坪效
	'constant_keliu': '客流',                    // 客流
	'constant_chengjiaolv': '成交率',             // 成交率
	'constant_jiandanjia': '件单价',              // 件单价
	'constant_mubiao': '目标',                     // 目标
	'constant_quarter': '季度',                   // 季度
	'constant_week_W': '周',
	'constant_quarter_Q': '季度',
	'constant_xiaoshoue_unit': '销售额(元)',                // 销售额(元)
	'constant_kedanjia_unit': '客单价(元/单)',                // 客单价(元/单)
	'constant_chengjiaolv_unit': '成交率(%)',             // 成交率(%)
	'constant_keliu_unit': '客流(人)',             // 客流(人)
	'constant_renxiao_unit': '人效(元/人)',                // 人效(元/人)
	'constant_pingxiao_unit': '坪效(元/平米)',         // 坪效(元/平米)
	'constant_jiandanjia_unit': '件单价(元/件)',       // 件单价(元/件)
	'constant_time': '时间',                            // 时间
	'constant_tianqi': '天气',                         // 天气
	'constant_no_data': '当前数据为空',                // 无数据是显示
	'constant_all': '全部',                            // 全部
	'constant_loading': '加载中...',                  // 加载中...
	'constant_cancel': '取消',                         // 取消
	'constant_confirm': '确定',                        // 确定
	'constant_1month': '1月',                         // 1月
	'constant_2month': '2月',                         // 2月
	'constant_3month': '3月',                         // 3月
	'constant_4month': '4月',                         // 4月
	'constant_5month': '5月',                         // 5月
	'constant_6month': '6月',                         // 6月
	'constant_7month': '7月',                         // 7月
	'constant_8month': '8月',                         // 8月
	'constant_9month': '9月',                         // 9月
	'constant_10month': '10月',                         // 10月
	'constant_11month': '11月',                         // 11月
	'constant_12month': '12月',                         // 12月
	'constant_weixuanze': '未选择',               // 未选择
	'constant_start_time': '开始时间',             // 开始时间
	'constant_end_time': '结束时间',                  // 结束时间
	'constant_tishi': '提示',                       // 提示
	'constant_week_ri': '日',                       // 星期日
	'constant_week_1': '一',                       // 星期1
	'constant_week_2': '二',                       // 星期2
	'constant_week_3': '三',                       // 星期3
	'constant_week_4': '四',                       // 星期4
	'constant_week_5': '五',                       // 星期5
	'constant_week_6': '六',                       // 星期6
	/**
	 * 主页
	 */
	'homePage_dateTypeMap': [                       // 首页头部模态框
		{ value: 1, label: '今日', bannerLabel:"今日" },
		{ value: 2, label: '本周', bannerLabel: "本周" },
		{ value: 3, label: '本月', bannerLabel: "本月" },
		{ value: 4, label: '本季度', bannerLabel :"本季度" },
		{ value: 5, label: '今年', bannerLabel :"今年" },
	],
	'homePage_sale_array': [                       // 首页头部模态框
		{ value: 1, label: '今日' },
		{ value: 2, label: '本周' },
		{ value: 3, label: '本月' },
		{ value: 4, label: '本季度' },
		{ value: 5, label: '今年' },
	],
	'homePage_tabList': [                           // 首页tab列表
		{
			value: typeEnumConst.saleNum,
			label: '销售额',
			unit: '元',
		},
		{
			value: typeEnumConst.customerFlow,
			label: '客流',
			unit: '人',
		},
		{
			value: typeEnumConst.turnoverRatio,
			label: '成交率',
			unit: '%',
		},
		{
			value: typeEnumConst.associatedPurchaseRate,
			label: '连带率',
			unit: '',
		},
	],
	'homePage_enterprise_overview': '企业概览',           // 企业概览按钮
	'homePage_cycle_unset_top': '未设置',                  // 首页圆环按钮未设置时上面的字
	'homePage_cycle_unset_bottom': '目标',                  // 首页圆环按钮未设置时下面的字
	'homePage_this_month_sale': '本月销售额',               // 本月销售额
	'homePage_this_year_sale': '本年销售额',               // 本年销售额
	'homePage_noStoreAlertInfo': '对接销售数据，了解企业经营动态，您还有{num}家门店尚未对接',         //点击感叹号的弹出字
	'homePage_the_average': '平均值',                       // 平均值
	'homePage_alert_noMessage': '您还未导入相关销售数据，您可以切换客流数据进行浏览，或者联系我们进行数据对接。拨打电话: ',  // 弹出提示
	'homePage_month_complete': '本月完成',               // 完成情况本月完成
	'homePage_year_complete': '本年完成',               // 完成情况本年完成
	'homePage_yichang_text': '{name}异常   请咨询: 400-100-1392',          // 异常显示情况
	'homePage_call_phone': '拨打电话',                    // 拨打电话
	'homePage_zhengchang_text': '距平均：',           // 正常情况显示
	'homePage_kanban': '看板',                          // 看板
	'homePage_shaixuan': '筛选',                        // 筛选
	'homePage_paiming': '排名',                          // 排名
	/**
	 * 区域概览
	 */
	'stateMent_title_area': '区域概览',                 // 头部标题区域概览
	'stateMent_title_company': '企业概览',                 // 头部标题企业概览
	'stateMent_data_title': '核心数据',                          // 核心数据title
	'stateMent_data_subtitle': '数据详情',                       // 核心数据subtitle
	'stateMent_indicator_tabList': [                       // 时间tab
		{
			label: '今日',
			value: 1,
		},
		{
			label: '本周',
			value: 2,
		},
		{
			label: '本月',
			value: 3,
		},
	],
	'stateMent_sequential_fell': '环比下降',              // 环比下降
	'stateMent_sequential_rose': '环比增长',              // 环比增长
	'stateMent_chart_title': '客流与销售额关联分析',     // 图表分析title
	'stateMent_sales_amount': '销售数量',                 // 销售数量
	'stateMent_number_flow': '客流数',                 // 客流数
	'stateMent_target_none': '销售目标未配置',              // 图标目标未配置提醒
	'stateMent_target_config': '立即配置',               // 立即配置
	'stateMent_title_storerank': '门店月销售排名',            // 门店月销售排名
	'stateMent_subtitle_storerank': '排名详情',              // 排名详情
	'stateMent_title_alarm': '告警消息',            // 告警消息
	'stateMent_subtitle_alarm': '消息列表',              // 消息列表
	'stateMent_no_storerank': '暂无排名',                 // 暂无排名
	'stateMent_no_alarm': '暂无告警信息',                  // 暂无告警信息
	'stateMent_find_detail': '了解详情',                   // 了解详情
	/**
	 * 销售目标
	 */
	'saleTarget_saleTarget_config_title': '销售目标配置',         // 销售目标配置
	'saleTarget_save_target': '保存配置',                // 保存配置
	'saleTarget_name_title': '{name}年销售目标',               // 门店名加时间的title
	'saleTarget_last_year_sale': '上年销售额',                // 上年销售额
	'saleTarget_money_units': ["元", "万元", "亿元", "万亿"],   // 单位
	'saleTarget_danwangji': '淡旺季权重分配',                     // 淡旺季权重分配
	'saleTarget_now_target': '当前目标数据：',                  // 当前目标数据
	'saleTarget_target_poor': '于年目标相差：',                 // 于年目标相差
	'saleTarget_table_head': ['季度','目标数据（万）','上年参考（万）'],   // table的表头
	'saleTarget_area_config': '区域权重分配',                   //区域权重分配
	'saleTarget_average_btn': '自动平均分配',                   // 自动平均分配
	/**
	 * 门店信息
	 */
	'storeData_today_keliu': '今日客流',                         // 今日客流
	'storeData_compare_yesterday': '对比昨日',                         // 对比昨日
	'storeData_data_analyse': '数据分析',                         // 数据分析
	'storeData_date_array': ['昨日','上周','上月','上季度','前日','上上周','上上月','上上季'],     // 客流分析下拉框
	'storeData_mingci': '名词解释',                              // 名词解释
	'storeData_data_mingci_text': [                            // 数据分析名词解释
		'客流量：进入店铺的客流',
		'销售额：销售额',
		'订单数：客户购买的产生的小票数量',
		'成交率：订单数/客流量*100%',
		'客单价：销售总金额/订单总数',
		'连带率：销售商品总数量/订单总数*100%',
		'件单价：销售总额/销售商品总数量',
	],  
	'storeData_month_xiaolv': '月门店效率',                      // 月门店效率                     
	'storeData_month_mingci_text': [                            // 月门店效率名词解释
		'人效：销售额/门店员工数量',
		'坪效：销售额/门店面积'
	],
	'storeData_title_alarm': '告警信息',                         // 告警信息
	'storeData_subtitle_alarm': '消息列表',                     // 消息列表
	'storeData_alert_mes': '了解更多数据指标，请联系管理员进行门店经纬度，店员数量，门店面积数据配置。',   
	'storeData_jingweidu': '经纬度',                            // 经纬度
	'storeData_mianji': '面积',
	'storeData_renyuan': '人员',                                 
	'storeData_alert_config': '门店{mes}未配置',
	/**
	 * 区域数据
	 */
	'areaData_select_area': '选择区域',                                   // 选择区域
	'areaData_analyse': '门店分析',                               // 门店分析
	'areaData_choose_time': '时间选择',                          // 时间选择
	'areaData_jiejiahuodong': '节假日/活动日',                         // 节假日/活动日
	'areaData_huodong': '活动日',                                  // 活动日
	'areaData_huanbi': '环比',                                      // 环比
	/**
	 * 销售排行
	 */
	'saleRank_datetype_list': [                                   // 销售排行头部时间切换
		{value: 1, label: '门店日排名'},
    {value: 3, label: '门店月排名'},
    {value: 4, label: '门店季度排名'},
	],
	'saleRank_rank': '排名',                                         // 表格头column
	'saleRank_store': '门店',                                         // 表格头column     =
	/**
	 * 排名
	 */    
	'rank_title': '{name}排名',                                      // 排名title
	'rank_find_detail_btn': '查看详细排名',                        // 查看详细排名按钮文字
	/**
	 * 告警
	 */
	'alarm_all_store': '全部门店',                                  // 全部门店
	'alarm_jibie': '级别',                                           // 级别
	/**
	 * 加载页
	 */
	'loading_wuquanxian': '您还没有任何门店权限，请联系管理员开通后使用本功能',     // 加载页无权限时显示
	/**
	 * 门店销售情况
	 */
	'sale_store_detail': '门店主页',                                  // 门店主页
	'sale_today_title': '今日{name}',                                // 今日+name组成的title
	'sale_compare_lastday': '对比昨日',                              // 对比昨日
	'sale_the_month_xiaoshoue': '月累计销售额',                     // 月累计销售额
	'sale_last_month_xiaoshoue': '上月累计销售额',                  // 上月累计销售额
	'sale_qushi': '{name}趋势',                                       // 趋势
	'sale_pingjun': '平均水平',                                        // 平均水平
	'sale_tongbi': '同比',                                             // 同比
	'sale_click_more': '点击加载更多',                                // 点击加载更多
	'sale_has_all_mes': '已加载全部数据',                             // 已加载全部数据
	'sale_jiejiari_compare': '节假日对比',                           // 节假日对比
	'sale_month_no_jiejiari': '本月无节假日',                        // 本月无节假日
	'sale_store_rank': '本店{name}排名',                            // 本店排名
	'sale_detail_rank': '详细排名',                                   //详细排名
	'sale_mingci': '名次',                                             // 名次
	/**
	 *  选择门店
	 */
	'chooseStore_select_store': '选择门店',                          // 选择门店
	'chooseStore_cancel': '取消',                                     // 取消
	'chooseStore_search': '搜索',                                     // 搜索
}